import { gql } from "@apollo/client";

export const IMPORT_BAND_DATA_ARRAY = gql`
  mutation importBandDataArray($bands: [ImportBandInput!]!) {
    importBandDataArray(bands: $bands) {
      id
      externalId
      source
      updatedAt
    }
  }
`;
